import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from 'react-toastify';
import TapSelect from '../../components/ui/TapSelect';
import tapIcon from '../../services/TapIcon';
import { connect, useSelector } from 'react-redux';
import Loader from "../../components/ui/Loader/Loader";
import HttpAPICall from "../../services/HttpAPICall";
import ApplicationLayout from '../../layouts/ApplicationLayout';
import { Helmet } from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import SiteProductivityModal from './SiteProductivityModal';
import TapIcon from '../../services/TapIcon';

const NewSiteProdAdd = (props) => {
    const site_productivity_url =   `${IAM_API_BASE_URL_2}/site_productivity/multiple_add`;
    const site_productivity_formData_url=   `${IAM_API_BASE_URL_2}/site_productivity/form_data`;
    const iamUserSite           =   useSelector(state => state.app.user_sites);
    const accessToken           =   useSelector(state => state.auth.access_token);
    const siteProductivityModalRef  =   useRef(null);

    const initAddProductivityForm   =   {
        transaction_date                :   "",
        site_id                         :   "",
        productivity_data               :   [],
    };

    const [siteProductivity, setSiteProductivity] = useState({
        saveFormSubmitting: false,
        addProductivityForm: { ...initAddProductivityForm },
        configurationData: [],
        allSites: [],
        activityListLoading: false,
        editProductivity: false,
        selectedEmployee: []
    });

    useEffect(() => {
        setSiteProductivity(prevState => ({
            ...prevState,
            allSites: iamUserSite.map(s => ({ value: s.id, label: `${s.site_name} (${s.site_code})` }))
        }));

        if (props?.location?.state?.ConfigurationData?.id) {
            setSiteProductivity(prevState => ({
                ...prevState,
                addProductivityForm: {
                    ...initAddProductivityForm,
                    activity_id: props.location.state.ConfigurationData.id,
                }
            }));
            getStepFormData(props.location.state.ConfigurationData.id);
        }
    }, [props, iamUserSite]);

    const getStepFormData = (site_id, data = null) => {
        setSiteProductivity(prevState => ({ ...prevState, activityListLoading: true }));
        let params = { site_id };

        HttpAPICall.withAthorization('GET', site_productivity_formData_url, accessToken, params, {}, (resp) => {
            const respData = resp.data.map(d => ({...d, checked : true}));
            setSiteProductivity(prevState => ({
                ...prevState,
                configurationData: respData.length > 0 ? respData : [],
            }));
            respData.forEach((data) => {
                setSiteProductivity(prevState => ({
                    ...prevState,
                    addProductivityForm: {
                        ...prevState.addProductivityForm, 
                        productivity_data: [...prevState.addProductivityForm.productivity_data, 
                            {
                                activity_id     :   data.activity ? data.activity.id : '', 
                                activity_code   :   data.activity_code, 
                                uom             :   data.uom ? data.uom.id : '',
                                production      :   '', 
                                notes           :   '',
                                config_id       :   data.id 
                            }
                        ]
                    },
                }));
            });
        }).then(() => setSiteProductivity(prevState => ({ ...prevState, activityListLoading: false })));
    };

    const closeEvent = () => {
        const { location } = props;
        if (location && location.url) {
            props.history.push(location.url);
        } else {
            props.history.push({ pathname: `/site_productivity` });
        }
    };

    const initAttendanceModal = (index) => {
        if (siteProductivityModalRef.current) {
            let productivity_data   =   siteProductivity.addProductivityForm.productivity_data.length > 0 ? siteProductivity.addProductivityForm.productivity_data[index] : null;    
            siteProductivityModalRef.current.initModalHandler(index, productivity_data);
        }
      
    };

    const submitaddProductivityForm = (e) => {
        e.preventDefault();
        if (!siteProductivity.addProductivityForm.transaction_date) {
            toast.error("Please select transaction date");
            return;
        }
    
        if (!siteProductivity.addProductivityForm.site_id) {
            toast.error("Please select site");
            return;
        }
        let runApi          =   true;
        const productivityData = siteProductivity.addProductivityForm.productivity_data.filter(d => d.checked).map(data => {
            if(data.production == 0 || data.production == "") {
                runApi      =   false;
                toast.error("Net Productivity not accept 0 value.");
                return null;
            } 
            const activityFormData  =   {
                ...data,
                workstation_id          :   data.hasOwnProperty('workstation_id') ? data.workstation_id : "",
                material_id             :   data.hasOwnProperty('material_id') ? data.material_id : "",
                material_new            :   data.hasOwnProperty('material_new') ? data.material_new : "",
                attachment_id           :   data.hasOwnProperty('attachment_id') ? data.attachment_id : "",
                attachment_new          :   data.hasOwnProperty('attachment_new') ? data.attachment_new : "",
                employee_ids            :   data.hasOwnProperty('employee_ids') ? data.employee_ids : "",
                trip                    :   data.hasOwnProperty('trip') ? data.trip : "",
                additional_attributes   :   data.hasOwnProperty('additional_attributes') ? data.additional_attributes : {},
            };
            return activityFormData;
        }).filter(d => d);

        let formData        =   {
            ...siteProductivity.addProductivityForm, 
            productivity_data: productivityData
        }  
        if(runApi) {
            setSiteProductivity(prev => ({...prev, saveFormSubmitting: true}));
            HttpAPICall.withAthorization('POST',site_productivity_url,  accessToken,{},formData,
                (response) => {
                    toast.success(response.message || "Productivity saved successfully");
                    closeEvent();
                }
            ).then(() => {
                setSiteProductivity(prev => ({...prev, saveFormSubmitting: false}));
            });
        }
    };

    const handleInputChange = (name, value, index) => {
        let newProdData             =   { 
            ...siteProductivity.addProductivityForm.productivity_data[index],
            [name] : value,
            checked : true
        }
        setSiteProductivity(prevState => ({ 
            ...prevState, 
            addProductivityForm: {
                ...prevState.addProductivityForm, 
                productivity_data: siteProductivity.addProductivityForm.productivity_data.map((data, i) => {
                    return i === index ? newProdData : data
                })
            }, 
        }))
    };

    const handleModalData   =   (index, newProdData) => {
        setSiteProductivity(prevState => ({ 
            ...prevState, 
            addProductivityForm: {
                ...prevState.addProductivityForm, 
                productivity_data: siteProductivity.addProductivityForm.productivity_data.map((data, i) => {
                    return i === index ? {...data, ...newProdData} : data
                })
            }, 
        }))
    }


    const handleFormDatabyName  =   (name, value) => {
        setSiteProductivity(pre => ({
            ...pre,
            addProductivityForm: {
                ...pre.addProductivityForm,
                [name]: name === "transaction_date" ? moment(value).format('YYYY-MM-DD') : value
            }
        }));
    }

    const handleCheckedBox      =   (index) => {
        const configurationData =   siteProductivity.configurationData.map((d,i) => (i === index ? {...d, checked : !d.checked} : d)); 

        setSiteProductivity(prevState => ({
            ...prevState,
            configurationData,
        }));
    }


    const saveProductivityFormJsx = () => {
        return (
            <form className="bg-white p-3" onSubmit={submitaddProductivityForm}>
                <div className="row align-items-center my-3">
                    <div className="col-sm-3">
                        <label htmlFor="transaction_date" className="form-label require">Date of Transaction</label>
                    </div>
                    <div className="col-sm-4">

                        <DatePicker
                            selected={siteProductivity?.addProductivityForm?.transaction_date ?
                                moment(siteProductivity.addProductivityForm.transaction_date, 'YYYY-MM-DD').toDate() : null}
                            name="transaction_date"
                            onChange={(value) => handleFormDatabyName("transaction_date", value)}
                            maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                            dateFormat="dd-MMM-yyyy"
                            className="form-control"
                            required={true}
                            placeholderText="Please Enter Date of Transaction"
                            autoComplete="off"
                        />
                    </div>
                </div>

                <div className="row align-items-center mt-3">
                    <div className="col-sm-3">
                        <label htmlFor="site_id" className="form-label require">Site</label>
                    </div>
                    <div className="col-sm-4">
                        <TapSelect
                            changeEvent={(selectedOption) => {
                                if (selectedOption) {
                                    handleFormDatabyName("site_id", selectedOption.value);
                                    getStepFormData(selectedOption.value);
                                }else {
                                    handleFormDatabyName("site_id", "");
                                }  
                            }}
                            options={siteProductivity.allSites}
                            isSearchable={true}
                            isClearable={true}
                            required={true}
                            value={siteProductivity.allSites.find(m => m.value === siteProductivity.addProductivityForm?.site_id) || null}
                            placeholder="Please Select Site"
                        />
                    </div>
                </div>

                {siteProductivity.addProductivityForm.site_id && (
                    <div className="table-responsive mt-4">
                        {siteProductivity.activityListLoading ? (
                            <Loader />
                        ) : (
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th style={{ width: "7%" }}>Update</th>
                                        <th style={{ width: "20%" }}>Activity Name</th>
                                        <th style={{ width: "14%" }}>Activity Code</th>
                                        <th style={{ width: "14%" }}>UOM</th>
                                        <th style={{ width: "20%" }}>Net Productivity</th>
                                        <th style={{ width: "20%" }}>Notes</th>
                                        <th style={{ width: "5%" }}>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {siteProductivity.configurationData?.length > 0 ? (
                                        siteProductivity.configurationData.map((activity, index) => (
                                            <tr key={activity.id}>
                                                <td>
                                                    <input type='checkbox' checked={activity.checked} onChange={() => handleCheckedBox(index)}/>
                                                </td>
                                                <td>{activity.activity.activity_name || "-"}</td>
                                                <td>{activity.activity_code || "-"}</td>
                                                <td>{activity.uom ? activity.uom.measuring_unit : "-"}</td>
                                                <td>
                                                    <input
                                                        name="production"
                                                        type="number"
                                                        value={activity.production}
                                                        className="form-control"
                                                        placeholder="Enter Productivity"
                                                        onChange={(e) => handleInputChange(e.target.name, e.target.value, index)}
                                                        required={activity.checked ? "required" : ""}
                                                        disabled={activity.checked ? "" : "disabled"}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        name="notes"
                                                        type="text"
                                                        value={activity.notes}
                                                        className="form-control"
                                                        placeholder="Enter Notes"
                                                        onChange={(e) => handleInputChange(e.target.name, e.target.value, index)}
                                                        disabled={activity.checked ? "" : "disabled"}
                                                    />
                                                </td>
                                                <td className={["text-center", activity.checked ? "cursor_pointer" : "bg-light text-muted user-select-none pe-none"].join(" ")}
                                                    onClick={() => activity.checked ? initAttendanceModal(index) : null}>
                                                    <button type="button" aria-expanded="false" className="action-btn">
                                                        <TapIcon.FontAwesomeIcon icon={TapIcon.faPlusCircle} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className='text-center'><td colSpan="6">No records</td></tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                )}

                <div className="col-12 text-end fixed_footer mt-4">
                    <div className='row'>
                        <div className='offset-8 col-sm-4'>
                            {/* <button type="button" disabled={siteProductivity.saveFormSubmitting} onClick={closeEvent} className="btn btn-secondary mx-3">Cancel</button> */}
                            <button type="submit" disabled={siteProductivity.saveFormSubmitting || siteProductivity.activityListLoading} className="btn btn-primary mx-2">
                                Save {siteProductivity.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Site Productivity - Add</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>{siteProductivity.editProductivity ? "Edit" : "Add"} Site Productivity</h3>
                    <div className="text-end mt15">
                        <button onClick={closeEvent} disabled={siteProductivity.saveFormSubmitting} type="button" className="btn btn-secondary">
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        {saveProductivityFormJsx()}
                    </div>
                </div>
                <SiteProductivityModal
                    ref={siteProductivityModalRef}
                    configurationData={siteProductivity.configurationData}
                    onSave={handleModalData}
                />
            </div>
        </ApplicationLayout>
    );
};

export default NewSiteProdAdd;